
































import Vue from 'vue';
import { State, Getter } from 'vuex-class';
import Component from 'vue-class-component';
import { FinancialInstitutionState, FinancialInstitution } from '@/store/financial-institution/types';
const namespace = 'financialInstitution';

@Component
export default class LayoutHeader extends Vue {
	@State('financialInstitution') financialInstitution?: FinancialInstitutionState;
	@Getter('fiCompany', { namespace }) fiCompany?: FinancialInstitution;

	computed() {
			this.fiCompany;
		
	}

	imageLoaded() {
      this.$eventBus.$emit('image-loaded', true)
    }

	
}
